module.exports = __webpack_public_path__ + "img/DJ.a06e42b2.png";